module.exports = __webpack_public_path__ + "static/media/ENCONTRO_3_ED_FISICA.e01fcabe.pdf";